import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

export const HIGHLIGHTED_PADDING = 5;
export const OUTLINE_SIZE = 5;

const styles = createStyles({
  root: {
    position: 'absolute',
    backgroundColor: 'lightgreen',
    opacity: 0.5,
    zIndex: 11,
    cursor: 'pointer',
    '&:hover': {
      outline: `${OUTLINE_SIZE}px solid lightgreen`,
    },
  },
  orange: {
    '&:hover': {
      outline: `${OUTLINE_SIZE}px solid orange`,
    },
  }
});

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);